import { ChevronRightIcon } from "@heroicons/react/24/solid";
import HomeIcon from "@mui/icons-material/Home";
import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";
import { BreadcrumbLinkStyled, BreadcrumbStyled } from "./styles";

const formatBreadcrumb = (segment) => {
  return segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};


export default function CustomBreadcrumbs({ items }) {
  const router = useRouter();

  // Remove query params
  const cleanedPath = router.asPath.split("?")[0];
  const pathSegments = cleanedPath.split("/").filter((seg) => seg);

  // Default breadcrumbs from URL
  const fallbackBreadcrumbs = pathSegments.map((segment, index) => {
    const href = "/" + pathSegments.slice(0, index + 1).join("/");
    const isLast = index === pathSegments.length - 1;
    const label = formatBreadcrumb(segment);

    return isLast ? (
      <Typography
        key={href}
        color="#40249B"
        fontSize={"12px"}
        lineHeight={"20px"}
      >
        {label}
      </Typography>
    ) : (
      <BreadcrumbLinkStyled key={href} href={href} legacyBehavior>
        <a style={{ textDecoration: "none", color: "#40249B" }}>{label}</a>
      </BreadcrumbLinkStyled>
    );
  });

  // If items prop is valid, render them instead
  const dynamicBreadcrumbs =
    Array.isArray(items) && items.length > 0
      ? items.map(({ label, href }, idx) =>
          href ? (
            <BreadcrumbLinkStyled key={idx} href={href} legacyBehavior>
              <a style={{ textDecoration: "none", color: "#40249B" }}>
                {label}
              </a>
            </BreadcrumbLinkStyled>
          ) : (
            <Typography
              key={idx}
              color="#40249B"
              fontSize={"12px"}
              lineHeight={"20px"}
            >
              {label}
            </Typography>
          )
        )
      : fallbackBreadcrumbs;

  return (
    <BreadcrumbStyled
      separator={
        <ChevronRightIcon
          style={{ width: "20px", height: "20px", color: "#40249B" }}
        />
      }
      aria-label="breadcrumb"
    >
      <BreadcrumbLinkStyled href="/" legacyBehavior>
        <a
          style={{ textDecoration: "none", color: "#40249B", display: "flex" }}
        >
          <HomeIcon
            style={{ height: "22px", width: "20px", color: "#40249B" }}
          />
        </a>
      </BreadcrumbLinkStyled>
      {dynamicBreadcrumbs}
    </BreadcrumbStyled>
  );
}
